import { render, staticRenderFns } from "./AddQuestionGroups.vue?vue&type=template&id=3d48aa22&"
import script from "./AddQuestionGroups.vue?vue&type=script&lang=ts&"
export * from "./AddQuestionGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d48aa22')) {
      api.createRecord('3d48aa22', component.options)
    } else {
      api.reload('3d48aa22', component.options)
    }
    module.hot.accept("./AddQuestionGroups.vue?vue&type=template&id=3d48aa22&", function () {
      api.rerender('3d48aa22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/stay-inputs/AddQuestionGroups.vue"
export default component.exports